import { FC } from "react"
import { useNavigate } from "react-router"
import { CellDetailOverviewForm } from ".."
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { Icon, IconColor } from "@/components/shared/Icon"
import Toggle from "@/components/shared/Toggle"
import WithRoleFeatureToggle from "@/components/WithRoleFeatureToggle"
import { PageRoutes } from "@/constants/routes"
import { ButtonVariant } from "@/types/index"
import { Feature, UserRole } from "@/types/user"

interface ControlsProps {
   title: string
   form: CellDetailOverviewForm
   onToggle: (args: { maintenance: boolean } | { vacant: boolean }) => void
}

const Controls: FC<ControlsProps> = ({ title, form, onToggle }) => {
   const navigate = useNavigate()
   return (
      <Grid
         flexWrap="nowrap"
         justifyContent="space-between"
         className="cell-detail-overview__controls"
      >
         <GridItem
            xs={12}
            sm={12}
            md={5}
            lg={5}
            className="cell-detail-overview__header"
         >
            <Button
               className="cell-detail-overview__back-button"
               iconName="arrowLeft"
               iconPosition={ButtonIconPosition.LEFT}
               variant={ButtonVariant.LARGE}
               onClick={() => navigate(PageRoutes.FLOOR_OVERVIEW)}
            />
            <div className="cell-detail-overview__title">
               <div className="cell-detail-overview__title-label">
                  <Icon
                     name="cell"
                     color={IconColor.COOL_GRAY}
                  />
                  <span>Cell</span>
               </div>
               <div className="cell-detail-overview__alert-name-wrapper">
                  <h2>{title}</h2>
               </div>
            </div>
         </GridItem>
         <GridItem
            className="cell-detail-overview__controls-toggles-wrapper"
            xs={12}
            sm={12}
            md={2}
            lg={2}
         >
            <div className="cell-detail-overview__controls-toggles">
               {
                  <WithRoleFeatureToggle
                     feature={Feature.CELL_MAINTENANCE}
                     excludedRoles={[UserRole.MANAGEMENT]}
                  >
                     <Toggle
                        label="Maintenance"
                        onChange={(checked) =>
                           onToggle({ maintenance: checked })
                        }
                        value={form.maintenance}
                     />
                  </WithRoleFeatureToggle>
               }
               <Toggle
                  label="Occupied"
                  onChange={(checked) => onToggle({ vacant: !checked })}
                  value={!form.vacant}
               />
            </div>
         </GridItem>
      </Grid>
   )
}

export default Controls
